import "./Login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getResultadoExames } from "../api";

function Login() {
  const navigate = useNavigate();
  const [msg_error, setMsgError] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    const form_data = new FormData(e.target);
    const data = Object.fromEntries(form_data);

    const cpf = data.cpf;
    const dt_nascimento = data.dt_nascimento;
    const id_paciente = data.id_paciente;

    getResultadoExames(cpf, dt_nascimento, id_paciente)
      .then(({ data }) => {
        console.log(data);
        if (data.error) {
          setMsgError(data.message);
        } else {
          const exames_data = JSON.stringify(data);
          sessionStorage.setItem("exames-data", exames_data);
          navigate("/resultados");
        }
      })
      .catch((error) => console.log(error));
  };

  const logo = process.env.PUBLIC_URL + "/logo.svg";

  return (
    <div className="container-login">
      <div className="login">
        <div className="login-logo">
          <img src={logo} width={150} />
        </div>
        <p className="login-title">
          Olá! Informe os dados abaixo para acessar os resultados de seus
          exames:
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <div className="form-input">
              <label htmlFor="cpf">CPF</label>
              <input
                type="text"
                id="cpf"
                name="cpf"
                placeholder="Digite seu CPF"
                required="required"
              />
            </div>
            <div className="form-input">
              <label htmlFor="dt_nascimento">Data de Nascimento</label>
              <input
                type="date"
                id="dt_nascimento"
                name="dt_nascimento"
                required="required"
              />
            </div>
            <div className="form-input">
              <label htmlFor="id_paciente">ID do Paciente</label>
              <input
                type="text"
                id="id_paciente"
                name="id_paciente"
                placeholder="Informe o ID do Paciente"
                required="required"
              />
            </div>
          </div>
          <div className="form-btn">
            <button type="submit">CONSULTAR</button>
          </div>
        </form>
        {msg_error && (
          <div className="msg-error">
            <p>{msg_error}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
